import Overlay from './overlay.js';
import StickyHeader from './stickyHeader.js';
import SearchFlyout from './searchFlyout.js';
import Accordion from './accordion.js';

function init() {
    // ======================
    // MOBILE offCanvas Menu
    // ======================
    new Overlay({
        triggersSelector: '.js-nav__trigger',
        overlaySelector: '.js-menu__offcanvas',
        closeSelector: '.js-menu__btn--close',
        activeClass: 'is-open',
        isNavigation: true
    });

    // ======================
    // DESKTOP Flyout Menu
    // ======================
    new Overlay({
        triggersSelector: '.js-nav-main__trigger',
        overlaySelector: '.js-nav-main__overlay',
        closeSelector: '.js-nav-main__btn--close',
        activeClass: 'is-open',
        isNavigation: true
    });

    // ======================
    // Search Overlay
    // ======================
    new Overlay({
        triggersSelector: '.js-search__trigger',
        overlaySelector: '.js-search__overlay',
        closeSelector: '.js-search__close',
        activeClass: 'is-open',
        isNavigation: false
    });

    // ======================
    // Sticky Header magic
    // ======================
    new StickyHeader();

    // ======================
    // SearchFlyout
    // ======================
    new SearchFlyout();

    // ======================
    // Accordion
    // ======================
    new Accordion();
}

// run when dom is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}